export const ValidatorPattern = {
  // Multi-label domains (country-code TLDs): name@messenger.com.br, name@company.co.uk
  Email_Validator:
    '^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}$',
  NANPPhoneValidation:
    '^(?:[2-9][0-9]{2}-[2-9][0-9]{2}-[0-9]{4}|[2-9][0-9]{2}[2-9][0-9]{2}[0-9]{4})$',
  PhoneValidationWith10NumbersHyphen: '^[0-9-]+$',
  alphanumericWithSpace: /[^a-zA-Z0-9 ]/g,
  alphabetsWithSpace: /[^a-zA-Z ]/g,
  alphaNumerics: /^[a-zA-Z0-9]*$/,
  NineDigitThreeDecimal: /^\d{0,9}\.?\d{0,3}$/g,
  SevenDigitTwoDecimal: /^\d{0,7}\.?\d{0,2}$/g,
  twoLetterCode: /^[A-Z]{2}$/i,
  stateCodeWithDash: /^([A-Z]{2})\s*-\s*/i
};
